import request from '@/utils/request'

/**
 *  获取拜访记录列表
 */
export function getCustomerVisitAPI(params){
    return request({
        url:'/customer/visit/list',
        headers: {
            isToken: true,
        },
        method: 'get',
        params: params
    })
}

/**
 * 根据拜访记录ID查询拜访记录详情
 */
export function getCustomerVisitById(id){
    return request({
        url:'/customer/visit/' + id,
        headers: {
            isToken: true,
        },
        method: 'get',
    })
}

/**
 * 查询所属客户
 */
export function selectCustomerCompanyListAll(params){
    return request({
        url:'/customer/company/selectCustomerCompanyListAllForSelect',
        headers: {
            isToken: true,
        },
        method: 'get',
        params: params
    })
}

/**
 *  获取拜访人
 * @param params
 * @returns {*}
 */
export function selectCustomerByCompany(params){
    return request({
        url:'/customer/user/selectCustomerByCompany?companyId=' + params,
        headers: {
            isToken: true,
        },
        method: 'get',
        params: params
    })
}

/**
 * 保存拜访记录
 */
export function saveCustomerVisitAPI(data){
    return request({
        url:'/customer/visit',
        headers: {
            isToken: true,
        },
        method: 'post',
        data: data
    })
}

/**
 * 更新拜访记录
 */
export function updateCustomerVisitAPI(data){
    return request({
        url:'/customer/visit',
        headers: {
            isToken: true,
        },
        method: 'put',
        data: data
    })
}